<template>
  <div :class="['nav-bar', bgOpacity == 0 ? 'nab-transparent' : '']">
    <img v-if="bgOpacity == 0" class="head-logo" src="https://cfes.oss-cn-beijing.aliyuncs.com/images/logo_white.png"
      alt="LOGO" />
    <img v-else class="head-logo" src="https://cfes.oss-cn-beijing.aliyuncs.com/images/logo.png" alt="LOGO" />
    <ul class="head-nav f-clear">
      <li :class="{ active: isActive('/') }"><a href="javascript:;" @click="changeRouter('/')">首页</a></li>
      <li :class="{ active: isActive('/case') }" @mouseover="isVisible = true" @mouseleave="isVisible = false">
        <a href="javascript:;" @click="changeRouter('/case')">案例</a>
        <ul class="head-nav_child" v-show="isVisible">
          <li v-for="a in caseList" :key="a.id">
            <a href="javascript:;" @click="changeCaseType(a.id, 0)">{{ a.name }}</a>
            <ul class="head-nav_second-child" v-if="a.child.length > 0">
              <li v-for="b in a.child" :key="b.id">
                <a href="javascript:;" @click="changeCaseType(a.id, b.id)">{{ b.name.split("：")[0] }}</a>
              </li>
            </ul>
          </li>
        </ul>
      </li>
      <li :class="{ active: isActive('/about') }"><a href="javascript:;" @click="changeRouter('/about')">关于</a></li>
      <li :class="{ active: isActive('/service') }"><a href="javascript:;" @click="changeRouter('/service')">服务</a></li>
      <li :class="{ active: isActive('/share') }"><a href="javascript:;" @click="changeRouter('/share')">分享</a></li>
      <li :class="{ active: isActive('/contact') }"><a href="javascript:;" @click="changeRouter('/contact')">联系</a></li>
    </ul>
  </div>
</template>

<script>
import {
  EventBus
} from "@/utils/event-bus.js";
export default {
  name: "navbar",
  components: {},
  props: {
    bgOpacity: { // 背景透明度，暂定0或1
      type: Number,
      default: 1,
      validator: function (value) {
        return value >= 0 && value <= 1;
      }
    }
  },
  data() {
    return {
      activeTab: '/',
      caseList: [],
      isVisible: false,
    }
  },
  created() {
    let num = 0;
    let caseList = [];
    let times = setInterval(() => {
      caseList = this.$store.state.caseList;
      num++;
      if (caseList.length || num > 500) {
        clearInterval(times);
        this.caseList = caseList;
      }
    }, 10);
  },
  mounted() { },
  computed: {},
  watch: {
    '$route'(to, from) {
      this.activeTab = to.path;
      if (to.path == "/caseInfo") {
        let types = JSON.parse(sessionStorage.getItem("caseType"));
        this.activeTab = types.page;
      }
    },
  },
  methods: {
    isActive(path) {
      return this.activeTab === path;
    },
    changeCaseType(s, c) {
      let path = this.$route.path;
      let caseItem = this.caseList.find(a => a.id == s);
      let cId = c;
      if (c == 0 && caseItem.child && caseItem.child.length > 0) cId = caseItem.child[0].id;
      sessionStorage.setItem('caseType', JSON.stringify({
        page: "/case",
        sId: s,
        cId: cId
      }));
      if (path == "/caseInfo" || path.indexOf("case") == -1) {
        this.$router.push({
          path: '/case',
          query: {
            id: cId || s
          }
        });
      } else {
        EventBus.$emit("setCaseIds", "change");
        this.isVisible = false
      }
    },
    changeRouter(path) {
      let nPath = this.$route.path;
      if (nPath != path) {
        sessionStorage.setItem('caseType', JSON.stringify({
          page: path,
          sId: 4,
          cId: 0
        }));
        if (path == "/case") {
          this.$router.push({
            path,
            query: {
              id: 4
            }
          });
        } else {
          this.$router.push(path);
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.nav-bar {
  width: 100%;
  // overflow: hidden;
  padding: 0 8.35rem;
  height: 5.525rem;
  background-color: #FFF;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #000;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  transition: all 500ms;

  .head-logo {
    width: 11.875rem;
    transition: all 500ms;
  }

  .head-nav > li {
    margin: 0 1rem;
    float: left;
    position: relative;
    padding-bottom: 1.7rem;

    a {
      display: inline-block;
      font-size: 0.95rem;
      height: 5.525rem;
      line-height: 9rem;
      font-family: '思源黑体 CN';
      transition: color 300ms;
    }

    &:hover > a,
    &.active > a {
      color: #FF6600;
      border-bottom: 0.2rem solid #FF6600;
    }

    // &:hover > .head-nav_child {
    //   // display: block;
    // }

    .head-nav_child {
      position: absolute;
      background-color: #040000;
      color: #FFF;
      top: 5.525rem;
      width: 5.5rem;
      z-index: 9999;
      transition: all 2000ms;
      // display: none;

      li {
        position: relative;
        width: 100%;

        a {
          width: 100%;
          height: 1.45rem;
          line-height: 1.45rem;
          font-size: 0.7rem;
          padding-left: 0.9rem;
        }

        .head-nav_second-child {
          position: absolute;
          left: 5.5rem;
          top: 0;
          background-color: #040000;
          display: none;
          width: max-content;

          li {
            a {
              padding: 0 1rem;
              width: 100%;
            }
          }
        }


        &:hover {
          background-color: #A0A0A0;

          .head-nav_second-child {
            display: block;
          }
        }
      }
    }
  }
}

.nab-transparent {
  background-color: transparent;

  .head-nav > li > a {
    color: #FFF;
  }
}
</style>
